import EVALUATION_STATUSES from '../../../constants/evaluationStatuses.constant';

class EvaluationService {
    constructor(
        $state,
        $http,
        $window,
        $stateParams,
        $rootScope,
        Upload,
        $mdDialog,
        $mdToast,
        $q,
    ) {
        this.$state = $state;
        this.$http = $http;
        this.$window = $window;
        this.$rootScope = $rootScope;
        this.Upload = Upload;
        this.$mdDialog = $mdDialog;
        this.$mdToast = $mdToast;
        this.$q = $q;
        this.evaluationId = $stateParams.id;
        this.currentEvaluation = null;
        this.displayPromptOnRedirct = true;
    }

    setEvaluationData(evaluationId, evaluationData, isMini) {
        const stateMode = isMini ? 'mini' : 'evaluation';
        this.evaluationId = evaluationId;
        return this.$http({
            method: 'POST',
            url: `api/${stateMode}/${this.evaluationId}/basic_info`,
            data: evaluationData,
            headers: {
                'Content-Type': 'application/json',
                authentication: localStorage.getItem('kes_token'),
            },
        }).then(
            (res) => {
                this.currentEvaluation = res.data;
                return res.data;
            },
            error => this.$q.reject(error),
        );
    }

    setEvaluationImageData(imageData, isMini) {
        const stateMode = isMini ? 'mini' : 'evaluation';
        return imageData ?
            this.Upload.upload({
                url: `api/${stateMode}/${this.evaluationId}/image`,
                method: 'POST',
                file: imageData,
                data: {},
            }) :
            new Promise(resolve => resolve(true));
    }

    getId(id, isMini) {
        const stateMode = isMini ? 'mini' : 'evaluation';
        return id && !isNaN(id) ?
            new Promise((resolve) => {
                resolve({ id });
            }) :
            this.$http({
                method: 'POST',
                url: `api/${stateMode}`,
                headers: {
                    'Content-Type': 'application/json',
                    authentication: localStorage.getItem('kes_token'),
                },
                data: {},
            }).then(
                res => res.data,
                error => this.$q.reject(error),
            );
    }

    getJoinId(parentId) {
        return this.$http({
            method: 'POST',
            url: 'api/evaluation/join',
            headers: {
                'Content-Type': 'application/json',
                authentication: localStorage.getItem('kes_token'),
            },
            data: {
                parent: parentId,
            },
        }).then(
            res => res.data,
            error => this.$q.reject(error),
        );
    }

    getSubEvaluationsById(parentId) {
        return this.$http({
            method: 'GET',
            url: `api/evaluation/sub/${parentId}`,
            headers: {
                'Content-Type': 'application/json',
                authentication: localStorage.getItem('kes_token'),
            },
            data: '',
        }).then(
            res => res.data,
            error => this.$q.reject(error),
        );
    }

    saveJustifications(data, evaluationId, showSuccess = true) {
        const stateMode = this.$state.includes('mini') ? 'mini' : 'evaluation';
        this.$http({
            method: 'POST',
            url: `api/${stateMode}/${evaluationId}/publish_justifications`,
            headers: {
                'Content-Type': 'application/json',
                authentication: localStorage.getItem('kes_token'),
            },
            data,
        }).then(
            () => {
                if (showSuccess) {
                    this.$mdToast.show(
                        this.$mdToast
                            .simple()
                            .textContent('Data saved successfully')
                            .position('top center')
                            .action('hide')
                            .highlightAction(true)
                            .hideDelay(400000)
                            .toastClass('success-toast'),
                    );
                }
            },
            error => this.$q.reject(error),
        );
    }

    saveImages(data, evaluationId) {
        const stateMode = this.$state.includes('mini') ? 'mini' : 'evaluation';
        this.$http({
            method: 'POST',
            url: `api/${stateMode}/${evaluationId}/publish_images`,
            headers: {
                'Content-Type': 'application/json',
                authentication: localStorage.getItem('kes_token'),
            },
            data,
        })
            .then(() => {
                this.$mdToast.show(
                    this.$mdToast
                        .simple()
                        .textContent('Data saved successfully')
                        .position('top center')
                        .action('hide')
                        .highlightAction(true)
                        .hideDelay(4000)
                        .toastClass('success-toast'),
                );
            })
            .catch(rejection => this.$q.reject(rejection));
    }

    uploadPublishImage(imageData) {
        if (imageData) {
            return this.Upload.upload({
                url: 'api/publish_image',
                method: 'POST',
                file: imageData,
                data: {},
                headers: {
                    authentication: localStorage.getItem('kes_token'),
                },
            });
        }
        return new Promise((resolve, reject) => reject());
    }

    convertImageToBase64(image) {
        const MAX_SIZE = 3000000;
        const deferred = this.$q.defer();
        if (image && image.size > MAX_SIZE) {
            return this.$q.reject({ status: 'TOO_LARGE' });
        }
        this.Upload.dataUrl(image, true).then((url) => {
            deferred.resolve(url);
        });
        return deferred.promise;
    }

    sendBasicForm(data, file, isMini) {
        return this.getId(data.id, isMini).then(
            response => this.setEvaluationData(response.id, data, isMini),
            rejection => this.$q.reject(rejection),
        );
    }

    getEvaluationsByLoggedUser() {
        return this.$http
            .get('/api/evaluation/list', {
                headers: {
                    'Content-Type': 'application/json',
                    authentication: localStorage.getItem('kes_token'),
                },
                data: {},
            })
            .then(
                res => res.data,
                error => this.$q.reject(error),
            );
    }

    getEvaluationsByProductId(productId) {
        return this.$http
            .get(`/api/product/${productId}/evaluation`, {
                headers: {
                    'Content-Type': 'application/json',
                    authentication: localStorage.getItem('kes_token'),
                },
                data: {},
            })
            .then(
                res => res.data,
                error => this.$q.reject(error),
            );
    }

    getEvaluationData(id, isMini = true) {
        return this.$http({
            method: 'GET',
            url: `api/mini/${id}`,
            headers: {
                'Content-Type': 'application/json',
                authentication: localStorage.getItem('kes_token'),
            },
            data: {},
        })
            .then((response) => {
                this.currentEvaluation = response.data;
                this.$rootScope.$broadcast(
                    'FRESH_EVALUATION_DATA',
                    this.currentEvaluation,
                );
                return response.data;
            })
            .catch(error => this.$q.reject(error));
    }

    getGdprSurvey(id) {
        return this.$http({
            method: 'GET',
            url: `api/survey/${id}`,
            headers: {
                'Content-Type': 'application/json',
                authentication: localStorage.getItem('kes_token'),
            },
            data: {},
        }).then(
            response => response.data,
            rejection => this.$q.reject(rejection),
        );
    }

    getSettingsSurvey() {
        return this.$http({
            method: 'GET',
            url: 'api/survey/settings',
            headers: {
                'Content-Type': 'application/json',
                authentication: localStorage.getItem('kes_token'),
            },
            data: {},
        }).then(
            response => response.data,
            rejection => this.$q.reject(rejection),
        );
    }

    patchSettingsAnswerExplanations(answerId, explanation) {
        return this.$http({
            method: 'PATCH',
            url: `api/survey/settings/answer/${answerId}`,
            headers: {
                'Content-Type': 'application/json',
                authentication: localStorage.getItem('kes_token'),
            },
            data: { explanation },
        })
            .then((response) => {
                this.$mdToast.show(
                    this.$mdToast
                        .simple()
                        .textContent('Your data has been saved successfully')
                        .position('top center')
                        .action('Hide')
                        .highlightAction(true)
                        .hideDelay(4000)
                        .toastClass('success-toast'),
                );

                this.displayPromptOnRedirct = false;
                return response.data;
            })
            .catch((response) => {
                this.$mdDialog.show(
                    this.$mdDialog.alert({
                        title: 'Some error occurred',
                        textContent:
                            'Your data with explanation has not been saved. Please try again.',
                        ok: 'OK',
                    }),
                );
                return this.$q.reject(response);
            });
    }

    patchSettingsFlagExplanations(descriptionId, description) {
        return this.$http({
            method: 'PATCH',
            url: `api/survey/settings/description/${descriptionId}`,
            headers: {
                'Content-Type': 'application/json',
                authentication: localStorage.getItem('kes_token'),
            },
            data: { description },
        })
            .then((response) => {
                this.$mdToast.show(
                    this.$mdToast
                        .simple()
                        .textContent('Your data has been saved successfully')
                        .position('top center')
                        .action('Hide')
                        .highlightAction(true)
                        .hideDelay(4000)
                        .toastClass('success-toast'),
                );

                this.displayPromptOnRedirct = false;
                return response.data;
            })
            .catch((response) => {
                this.$mdDialog.show(
                    this.$mdDialog.alert({
                        title: 'Some error occurred',
                        textContent:
                            'Your data with explanation has not been saved. Please try again.',
                        ok: 'OK',
                    }),
                );
                return this.$q.reject(response);
            });
    }

    getPARulersAvgScores(id) {
        return this.$http({
            method: 'GET',
            url: `api/evaluation/${id}/pedagogical_approach/rulers_average_scores`,
            headers: {
                'Content-Type': 'application/json',
                authentication: localStorage.getItem('kes_token'),
            },
            data: {},
        })
            .then(response => response.data)
            .catch(error => this.$q.reject(error));
    }

    exportEvaluation(evaluationId, isMini = true) {
        return this.$http({
            method: 'POST',
            url: `api/${isMini ? 'mini' : 'evaluation'}/${evaluationId}/export`,
            headers: {
                'Content-Type': 'application/json',
                authentication: localStorage.getItem('kes_token'),
            },
        }).then(
            response => response.data,
            rejection => this.$q.reject(rejection),
        );
    }

    getEvaluationNotes(id) {
        return this.$http({
            method: 'GET',
            url: `api/evaluation/${id}/note`,
            headers: {
                'Content-Type': 'application/json',
                authentication: localStorage.getItem('kes_token'),
            },
            data: {},
        }).then(
            response => response.data,
            rejection => this.$q.reject(rejection),
        );
    }

    saveEvaluationNote(id, text) {
        return this.$http({
            method: 'POST',
            url: `api/evaluation/${id}/note`,
            headers: {
                'Content-Type': 'application/json',
                authentication: localStorage.getItem('kes_token'),
            },
            data: { id, text },
        }).then(
            response => response.data,
            rejection => this.$q.reject(rejection),
        );
    }

    markNotesAsRead(notes) {
        return this.$http({
            method: 'POST',
            url: 'api/evaluation_note/read',
            headers: {
                'Content-Type': 'application/json',
                authentication: localStorage.getItem('kes_token'),
            },
            data: {
                notes: notes.map(e => e.id),
            },
        }).then(
            response => response.data,
            rejection => this.$q.reject(rejection),
        );
    }

    getOthers(items, isMini, id) {
        return this.$http({
            method: 'GET',
            url: `api/evaluation/${id}/finished/${items}`,
            headers: {
                'Content-Type': 'application/json',
                authentication: localStorage.getItem('kes_token'),
            },
            data: {},
        }).then(
            response => response.data,
            rejection => this.$q.reject(rejection),
        );
    }

    changePublishFlag(id, flags, now) {
        const saveMode = flags.publishDate || now ? 1 : 0;
        return this.$http({
            method: 'POST',
            url: `api/mini/${id}/publish_flags/${saveMode}`,
            headers: {
                'Content-Type': 'application/json',
                authentication: localStorage.getItem('kes_token'),
            },
            data: flags,
        })
            .then(response => response.data)
            .catch(response => this.$q.reject(response));
    }

    saveConclusions(id, conclusions) {
        return this.$http({
            method: 'POST',
            url: `api/mini/${id}/conclusions`,
            headers: {
                'Content-Type': 'application/json',
                authentication: localStorage.getItem('kes_token'),
            },
            data: conclusions,
        })
            .then((response) => {
                this.$mdToast.show(
                    this.$mdToast
                        .simple()
                        .textContent('Your data has been saved successfully')
                        .position('top center')
                        .action('Hide')
                        .highlightAction(true)
                        .hideDelay(4000)
                        .toastClass('success-toast'),
                );

                this.displayPromptOnRedirct = false;
                return response.data;
            })
            .catch((response) => {
                this.$mdDialog.show(
                    this.$mdDialog.alert({
                        title: 'Some error occurred',
                        textContent:
                            'Your data has not been saved. Please try again.',
                        ok: 'OK',
                    }),
                );
                return this.$q.reject(response);
            });
    }

    saveExportedConclusions(id, conclusions) {
        return this.$http({
            method: 'POST',
            url: `api/mini/${id}/conclusions_summary`,
            headers: {
                'Content-Type': 'application/json',
                authentication: localStorage.getItem('kes_token'),
            },
            data: conclusions,
        })
            .then((response) => {
                this.$mdToast.show(
                    this.$mdToast
                        .simple()
                        .textContent('Your data has been saved successfully')
                        .position('top center')
                        .action('Hide')
                        .highlightAction(true)
                        .hideDelay(4000)
                        .toastClass('success-toast'),
                );

                this.displayPromptOnRedirct = false;
                return response.data;
            })
            .catch((response) => {
                this.$mdDialog.show(
                    this.$mdDialog.alert({
                        title: 'Some error occurred',
                        textContent:
                            'Your data has not been saved. Please try again.',
                        ok: 'OK',
                    }),
                );
                return this.$q.reject(response);
            });
    }

    savePedagogicalApproachAnswers(id, data, isMini) {
        const stateMode = isMini ? 'mini' : 'evaluation';
        return this.$http({
            method: 'POST',
            url: `api/${stateMode}/${id}/pedagogical_approach`,
            headers: {
                'Content-Type': 'application/json',
                authentication: localStorage.getItem('kes_token'),
            },
            data,
        })
            .then((response) => {
                this.$mdToast.show(
                    this.$mdToast
                        .simple()
                        .textContent('Your data has been saved successfully')
                        .position('top center')
                        .action('Hide')
                        .highlightAction(true)
                        .hideDelay(4000)
                        .toastClass('success-toast'),
                );
                this.displayPromptOnRedirct = false;
                return response.data;
            })
            .catch((response) => {
                this.$mdDialog.show(
                    this.$mdDialog.alert({
                        title: 'Some error occurred',
                        textContent:
                            'Your data has not been saved. Please try again.',
                        ok: 'OK',
                    }),
                );
                return this.$q.reject(response);
            });
    }

    saveCustomerForm(data, secret) {
        return this.$http({
            method: 'POST',
            url: `/api/evaluation/customer_form/${secret}`,
            data,
            headers: {
                'Content-Type': 'application/json',
                authentication: localStorage.getItem('kes_token'),
            },
        }).then(
            response => response.data,
            rejection => this.$q.reject(rejection),
        );
    }

    getLatestEvaluation(id) {
        return this.$http({
            method: 'GET',
            url: `/api/evaluation/latest/${id}`,
            headers: {
                'Content-Type': 'application/json',
                authentication: localStorage.getItem('kes_token'),
            },
            data: {},
        }).then(
            response => response.data,
            rejection => this.$q.reject(rejection),
        );
    }

    getLatestInvitations() {
        return this.$http({
            method: 'GET',
            url: '/api/evaluation/invitations',
            headers: {
                'Content-Type': 'application/json',
                authentication: localStorage.getItem('kes_token'),
            },
            data: {},
        }).then(
            response => response.data,
            rejection => this.$q.reject(rejection),
        );
    }

    copyLatestEvaluation(productId, stateMode) {
        return this.$http({
            method: 'POST',
            url: `api/product/${productId}/evaluation/${stateMode}`,
            headers: {
                'Content-Type': 'application/json',
                authentication: localStorage.getItem('kes_token'),
            },
            data: {},
        })
            .then(response => response.data)
            .catch((response) => {
                this.$mdDialog.show(
                    this.$mdDialog.alert({
                        title: 'Some error occurred',
                        textContent:
                            'The copy has not been created. Please try again.',
                        ok: 'OK',
                    }),
                );
                return this.$q.reject(response);
            });
    }

    upgradeToFull(id) {
        return this.$http({
            method: 'POST',
            url: `api/mini/${id}/upgrade`,
            headers: {
                'Content-Type': 'application/json',
                authentication: localStorage.getItem('kes_token'),
            },
        })
            .then(response => response.data)
            .catch((response) => {
                this.$mdDialog.show(
                    this.$mdDialog.alert({
                        title: 'Some error occurred',
                        textContent:
                            'The copy has not been created. Please try again.',
                        ok: 'OK',
                    }),
                );
                return this.$q.reject(response);
            });
    }

    downgradeToMini(id) {
        return this.$http({
            method: 'POST',
            url: `api/evaluation/${id}/downgrade`,
            headers: {
                'Content-Type': 'application/json',
                authentication: localStorage.getItem('kes_token'),
            },
        })
            .then(response => response.data)
            .catch((response) => {
                this.$mdDialog.show(
                    this.$mdDialog.alert({
                        title: 'Some error occurred',
                        textContent:
                            'The copy has not been created. Please try again.',
                        ok: 'OK',
                    }),
                );
                return this.$q.reject(response);
            });
    }

    deleteEvaluation(evaluation) {
        return this.$http({
            method: 'DELETE',
            url: `api/${evaluation.isMini ? 'mini' : 'evaluation'}/${
                evaluation.id
            }`,
            headers: {
                'Content-Type': 'application/json',
                authentication: localStorage.getItem('kes_token'),
            },
        }).then(
            response => response.data,
            rejection => this.$q.reject(rejection),
        );
    }

    checkIfSecretExists(secret) {
        return this.$http({
            method: 'GET',
            url: `/api/evaluation/customer_form/${secret}`,
            headers: {
                'Content-Type': 'application/json',
                authentication: localStorage.getItem('kes_token'),
            },
            data: {},
        }).then(
            response => response.data,
            rejection => this.$q.reject(rejection),
        );
    }

    finishEvaluation(id) {
        return this.$http({
            method: 'POST',
            url: `/api/evaluation/${id}/finished`,
            headers: {
                'Content-Type': 'application/json',
                authentication: localStorage.getItem('kes_token'),
            },
            data: {},
        }).then(
            response => response.data,
            rejection => this.$q.reject(rejection),
        );
    }

    unlockEvaluation(id) {
        return this.$http({
            method: 'POST',
            url: `/api/evaluation/${id}/unlock`,
            headers: {
                'Content-Type': 'application/json',
                authentication: localStorage.getItem('kes_token'),
            },
            data: {},
        }).then(
            response => response.data,
            rejection => this.$q.reject(rejection),
        );
    }

    sendEmailToClient(productId, isMini) {
        const stateMode = isMini ? 'mini' : 'evaluation';
        return this.$http({
            method: 'POST',
            url: `api/${stateMode}/${productId}/send_form`,
            headers: {
                'Content-Type': 'application/json',
                authentication: localStorage.getItem('kes_token'),
            },
        })
            .then((response) => {
                this.$mdToast.show(
                    this.$mdToast
                        .simple()
                        .textContent('The message has been send successfully')
                        .position('top center')
                        .action('Hide')
                        .highlightAction(true)
                        .hideDelay(4000)
                        .toastClass('success-toast'),
                );
                return response.data;
            })
            .catch((response) => {
                this.$mdDialog.show(
                    this.$mdDialog.alert({
                        title: 'Some error occurred',
                        textContent: 'The message has not been sent to client.',
                        ok: 'OK',
                    }),
                );
                return this.$q.reject(response);
            });
    }

    isBasicInfoEditable(status) {
        return [
            EVALUATION_STATUSES.NOT_STARTED,
            EVALUATION_STATUSES.PENDING,
            EVALUATION_STATUSES.FINISHED,
            EVALUATION_STATUSES.NOT_CERTIFIED,
        ].includes(status);
    }

    areLearningsEditable(status) {
        return EVALUATION_STATUSES.PENDING === status;
    }

    isPublishAccessible(status) {
        return ![
            EVALUATION_STATUSES.NOT_STARTED,
            EVALUATION_STATUSES.PENDING,
        ].includes(status);
    }

    isAfterFinish(status) {
        return [
            EVALUATION_STATUSES.FINISHED,
            EVALUATION_STATUSES.CERTIFIED,
            EVALUATION_STATUSES.NOT_CERTIFIED,
        ].includes(status);
    }
}

export default EvaluationService;



// WEBPACK FOOTER //
// ./src/app/pages/evaluation/services/evaluationService.js